//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'WebAboutSite',
  components: {},
  data() {
      return {
      }
  },
  async created() {
  },
  computed: {
    langNotEn() {
      return localStorage.getItem('keio.lang') !== 'en';
    }
  },
  watch: {},
  methods: {
  },
}
